package org.example.site_web.components.images


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import com.varabyte.kobweb.compose.dom.GenericTag
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.attr
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.theme.shapes.Path
import com.varabyte.kobweb.silk.theme.shapes.Rect
import kotlinx.coroutines.delay
import org.example.site_web.aiPalette
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.ElementScope
import org.w3c.css.masking.SVGMaskElement
import org.w3c.dom.svg.SVGElement


@Composable
fun MagGlassSvg(modifier: Modifier = Modifier, frame: Double) {
    Svg(
        attrs = modifier.toAttrs {
            viewBox(0, 0, 64, 64)
        }
    )
    {
        val agradient = SvgId("agradient")
        val argradient = SvgId("argradient")

        val offset = 100 - frame.toInt()
        val strokeW = 2

        Defs() {
            LinearGradient(id = argradient,
                Modifier.toAttrs{
                    attr("gradientTransform","rotate(90)")
                }) {
                Stop((0 ).percent, aiPalette.mainPalette.primary)
                Stop((100 ).percent, aiPalette.mainPalette.darkest)
            }

            RadialGradient(id = agradient) {
                Stop((0).percent, aiPalette.mainPalette.primary)
                //Stop((100-offset.value).percent, aiPalette.mainPalette.primary)
                Stop((100 - offset).percent, aiPalette.mainPalette.darkest)
                Stop((100).percent, aiPalette.mainPalette.darkest)
            }
        }
//        Mask(Modifier.toAttrs {
//            id("amask")
//        }) {
//            val cq = 22
//            val radius = 19
//            val lmanche = 28
//            val emanche = 10
//
//            Circle {
//                cx(cq)
//                cy(cq)
//                r(radius)
//                //fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//
//            Circle {
//                cx(cq)
//                cy(cq)
//                r(radius-6)
//                //fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//
//            Path {
//                d("M 0 0 A $radius $radius 0 0 1 0 $emanche L $lmanche $emanche A $radius $radius 0 0 0  $lmanche 0 L 0 0")
//                //fillRule(SVGFillRule.EvenOdd)
//                transform{
//                    rotate(45)
//                    translate(3*radius-emanche/2.0,-emanche/2.0)
//                }
//                fillRule(SVGFillRule.EvenOdd)
//                fill(Colors.White)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//        }

        Rect() {
            x(0)
            y(0)
            width(64)
            height(64)
            fill(argradient)
            attr("mask", "url(#mag-glass-mask)")
        }
    }

}

